<template>
  <v-dialog :value="value" persistent scrollable :width="960">
    <v-card>
      <v-card-title>
        <h1 class="headline ma-0">{{ $t('asset_wise.document_no') }}: {{ number }}</h1>
        <v-spacer />
        <v-btn icon flat @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <slot />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    number: {
      type: [String, Number],
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/Management/components/document/DocumentDialog.vue